<script>
import { zipCode } from "@/utils/form-validators";
import FormInput from "@/components/molecules/form-input";
import FormSelect from "@/components/molecules/form-select";
import FormSelectOption from "@/components/molecules/form-select/form-select-option";
import Button from "@/components/atoms/button";
import FormGroup from "@/components/molecules/form-group";
import Form from "@/components/molecules/form";
import FormFieldset from "@/components/molecules/form-fieldset";

export default {
  components: {
    FormInput,
    FormSelect,
    Button,
    FormSelectOption,
    FormGroup,
    Form,
    FormFieldset
  },
  props: {
    checkEligibilite: {
      type: Boolean,
      required: false,
      default: true
    },
    communes: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    state: {
      type: String,
      required: false,
      default: null
    },
    magasinName: {
      type: String,
      required: true
    }
  },
  emits: ["codePostalSelected", "resetCommunes", "communeValidated"],
  computed: {
    isValidCodePostal() {
      return zipCode(this.codePostal);
    }
  },
  data() {
    return {
      codePostal: "",
      communeId: null,
      timer: null
    };
  },
  methods: {
    handleCodePostal() {
      if (this.isValidCodePostal) {
        this.$emit("codePostalSelected", this.codePostal);
      } else {
        this.communeId = null;
        this.$emit("resetCommunes");
      }
    },
    handleInput() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.handleCodePostal(), 500);
    },
    communeValidated() {
      const commune = this.communes.find(
        (commune) => commune.id === this.communeId
      );
      if (commune) {
        this.$emit("communeValidated", {
          code_insee: commune.attributes.code_insee,
          code_postal: commune.attributes.code_postal,
          nom_commune: commune.attributes.nom_commune
        });
      }
    }
  }
};
</script>

<template>
  <Form
    class="u-ml-xlg u-mr-xlg u-mb-xlg u-pl-md u-pr-md u-text-center u-ml-none@sm u-mr-none@sm u-pl-none@sm u-pr-none@sm"
    @submit.prevent="communeValidated()"
  >
    <p
      v-if="checkEligibilite"
      class="u-font-15 u-mb-lg"
    >
      Tout d’abord, vérifions si votre commune peut être livrée par le magasin {{ magasinName }}
    </p>
    <p
      v-else
      class="u-font-15 u-mb-lg"
    >
      Tout d’abord, saisissez votre code postal pour trouver votre commune
    </p>
    <FormFieldset
      size="md"
      center
    >
      <FormGroup
        :state="isValidCodePostal ? state : null"
        inline
      >
        <FormInput
          id="cp"
          v-model="codePostal"
          class="u-mb-xs"
          type="tel"
          autocomplete="postal-code"
          pattern="[0-9]*"
          maxlength="10"
          @input="handleInput"
        >
          Code postal *
        </FormInput>
        <template #message>
          <p>
            Aucune commune n'a été trouvée pour le code postal {{ codePostal }}
          </p>
        </template>
      </FormGroup>

      <FormSelect
        title="Ville"
        v-model="communeId"
        :disabled="communes.length === 0"
      >
        <FormSelectOption :value="null">
          Ville *
        </FormSelectOption>
        <FormSelectOption
          v-for="commune in communes"
          :key="commune.id"
          :value="commune.id"
        >
          {{ commune.attributes.nom_commune }}
        </FormSelectOption>
      </FormSelect>
    </FormFieldset>

    <Button
      class="u-mt-lg"
      radius="full"
      variant="secondary"
      size="md"
      :disabled="!communeId"
      type="submit"
      :value="checkEligibilite ? 'Vérifier' : 'Suivant'"
    />
  </Form>
</template>
